// extracted by mini-css-extract-plugin
module.exports = {"root":"AboutArea_root__1edJS","aboutRubrik":"AboutArea_aboutRubrik__1se0Y","infoTextWrapper":"AboutArea_infoTextWrapper__1qaSP","infoText":"AboutArea_infoText__5jpqw"};